export default function({ state, commit, dispatch }, { id, patient, provider, previousObj, updateObj}) {


    //commit('startUpdatingPatient', update.id)
    return dispatch('patch', {
        url: '/provider/' + ( state.id ? state.id : provider ) + '/patient/' + patient + '/file/' + id,
        data: updateObj
    }, {
        root: true
    })
    .then((response) => {
        const newObj = {
            ...previousObj,
            comment: updateObj.comment
        }
        commit('updatePatient', {
            id: patient,
            file: [newObj]
        })
        //commit('updatePatient', patientRes)
        //commit('finishUpdatingPatient', update.id)
        return response
    })
    .catch((error) => {
        //commit('finishUpdatingPatient', update.id)
        throw error
    })
}
